import React from "react";

const TermsConditions = () => {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-5xl mx-auto px-6 py-10">
        <h1 className="text-3xl font-bold text-gray-800 mb-6">
          Terms & Conditions
        </h1>

        {/* <p className="text-gray-600 mb-6">Last updated: August 19, 2026</p> */}

        <p className="text-gray-700 leading-7 mb-6">
          These Terms & Conditions govern your access to and use of our mobile
          application and related services. By accessing or using the
          application, you agree to be bound by these terms.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-3">
          1. Use of the Application
        </h2>

        <p className="text-gray-700 leading-7 mb-4">
          The application is intended to provide educational, communication,
          management, and related services to authorized users. You agree to use
          the application only for lawful purposes and in accordance with these
          terms.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-3">
          2. User Accounts
        </h2>

        <p className="text-gray-700 leading-7 mb-4">
          Users are responsible for maintaining the confidentiality of their
          login credentials and for all activities performed through their
          accounts. Users should immediately notify the appropriate
          administrator if they believe their account has been compromised.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-3">
          3. Acceptable Use
        </h2>

        <p className="text-gray-700 leading-7 mb-4">
          You must not misuse the application, attempt unauthorized access,
          interfere with its operation, upload malicious content, or use the
          service for any unlawful purpose.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-3">
          4. Intellectual Property
        </h2>

        <p className="text-gray-700 leading-7 mb-4">
          The application, its software, design, content, trademarks, and
          related materials are owned by or licensed to the organization
          operating the application and are protected by applicable intellectual
          property laws.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-3">
          5. Third-Party Services
        </h2>

        <p className="text-gray-700 leading-7 mb-4">
          The application may integrate with third-party services. Your use of
          those services may be subject to additional terms and policies
          provided by the respective third-party providers.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-3">
          6. Availability of Services
        </h2>

        <p className="text-gray-700 leading-7 mb-4">
          We aim to keep the application available and functioning properly, but
          we do not guarantee that the service will always be uninterrupted,
          error-free, or available at all times.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-3">
          7. Limitation of Liability
        </h2>

        <p className="text-gray-700 leading-7 mb-4">
          To the extent permitted by applicable law, the organization operating
          the application will not be liable for indirect, incidental, or
          consequential damages arising from the use or inability to use the
          application.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-3">
          8. Termination
        </h2>

        <p className="text-gray-700 leading-7 mb-4">
          Access to the application may be suspended or terminated if a user
          violates these Terms & Conditions or engages in unauthorized or
          unlawful activity.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-3">
          9. Changes to These Terms
        </h2>

        <p className="text-gray-700 leading-7 mb-4">
          These Terms & Conditions may be updated from time to time. Continued
          use of the application after changes are published constitutes
          acceptance of the updated terms.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-3">
          10. Contact Us
        </h2>

        <p className="text-gray-700 leading-7">
          If you have questions regarding these Terms & Conditions, please
          contact the organization responsible for operating the application.
        </p>
      </div>
    </div>
  );
};

export default TermsConditions;
